import React from 'react';
export function Footer() {
  return <footer className="bg-deep-charcoal text-white py-12" data-id="element-37">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-38">
        <h2 className="font-heading text-2xl font-bold mb-6 text-warm-beige" data-id="element-39">
          El Código Hormonal 28D
        </h2>
        <p className="text-white/60 text-sm mb-8 max-w-2xl mx-auto" data-id="element-40">
          Este producto no sustituye el consejo médico profesional. Consulta a
          tu médico antes de realizar cambios significativos en tu dieta o
          rutina de ejercicios.
        </p>
        <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-sm text-white/40" data-id="element-41">
          <span data-id="element-42">
            &copy; {new Date().getFullYear()} El Código Hormonal. Todos los
            derechos reservados.
          </span>
          <span className="hidden md:inline" data-id="element-43">•</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-44">
            Términos y Condiciones
          </a>
          <span className="hidden md:inline" data-id="element-45">•</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-46">
            Política de Privacidad
          </a>
        </div>
      </div>
    </footer>;
}